import { AdvertisementCategory } from "@tm/models"
import { create } from "zustand"

type OffersStore = {
    categories: AdvertisementCategory[]
    selectedCategory: AdvertisementCategory | null
    offersTabActive: boolean
    currentCarouselPageIndex: number
    setCategories: (categories: AdvertisementCategory[]) => void
    setSelectedCategory: (selectedCategory: AdvertisementCategory) => void
    setOffersTabActive: (offersTabActive: boolean) => void
    setCurrentCarouselPageIndex: (currentCarouselPageIndex: number) => void
}

export const useOffersStore = create<OffersStore>((set) => ({
    categories: [],
    selectedCategory: null,
    offersTabActive: false,
    currentCarouselPageIndex: 0,
    setCategories: (categories) => {
        set((prev) => ({ ...prev, categories }))
    },
    setSelectedCategory: (selectedCategory) => {
        set((prev) => ({ ...prev, selectedCategory }))
    },
    setOffersTabActive: (offersTabActive) => {
        set((prev) => ({ ...prev, offersTabActive }))
    },
    setCurrentCarouselPageIndex: (currentCarouselPageIndex) => {
        set((prev) => ({ ...prev, currentCarouselPageIndex }))
    },
}))
